import { getEventHandlers } from './handlers/getEventHandlers'
import { set as initConfig } from './config'

export { set as initConfig } from './config'
export { getEventHandlers } from './handlers/getEventHandlers'
export type { ConfigType, EventDataParametersType } from './types'

if (typeof window !== 'undefined') {
  window.affiliateFrontendAnalyticsEventsPlainJS = {
    getEventHandlers,
    initConfig,
  }
  window.dispatchEvent(new Event('affiliateFrontendAnalyticsEventsPlainJS:ready'))
}
